import { Dropdown } from 'antd';
import { Observer } from 'mobx-react';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSwipeable } from 'react-swipeable';
import { PlusIcon, } from '../../../../assets/icons/common/common-icons';
import { ActionLocked } from '../../../../common/components/ActionLocked/ActionLocked';
import { ActionLockedIconWithTooltip } from '../../../../common/components/ActionLocked/ActionLockedIconWithTooltip';
import { MenuItemWrapper, MenuWrapper } from '../../../../common/components/DropDownMenu/DropDownMenu.styles';
import { LimitationModal } from '../../../../common/components/LimitationModal/LimitationModal';
import { LottieHoverIcon } from '../../../../common/components/LottieHoverIcon/LottieHoverIcon';
import { ROUTES } from '../../../../common/constants/routes.const';
import { navigateToURLWithState } from '../../../../common/utils/navigation.utils';
import { NewCreateItemModal } from '../../../add-item/components/NewCreateItemModal';
import { ADD_ITEM_STEP } from '../../../add-item/data/create-item.store';
import { useStore } from '../../../app/data/root.store';
import { VyzerAIAssistanceIcon } from '../../../assistance/assets/icons';
import { AssistanceHeroLogoText, AssistanceHeroLogoWrapper } from '../../../assistance/components/Assistance.styles';
import { ParamTitleSelectionCount } from '../../../filters/components/FiltersPanel.styles';
import { Notifications } from '../../../notifications/components/Notifications';
import { HeaderSearchBox } from '../HeaderSearchBox/HeaderSearchBox';
import './Header.css';
import { CreateButton, CreateMenuItemIcon, CreateMenuItemSubTitle, CreateMenuItemTextContent, CreateMenuItemTitle, CreateMenuItemWrapper, FiltersButton, HeaderActions, HeaderWrapper, MenuSectionHeader, NotificationsBellIconBadge, NotificationsButtonWrapper, NotificationsMenuWrapper, SearchBox } from './Header.styles';
import lottieFilterIcon from './icons/filter-icon.lottie.json';
import { CreateMenuInvsIcon, CreateMenuMagicBoxIcon, NotificationsBellIcon } from './icons/header-icons';

export function AppHeader(props) {
  const { withFilters, createBlack } = props;
  const { userStore, uiStore, createItemStore, notificationsStore, filtersStore, billingStore } = useStore();
  const [isNotificationPanelOpen, setIsNotificationPanelOpen] = useState(false);  // window.localStorage.getItem('showNotifications') === '1');
  const filterButtonRef = useRef(null);
  const [isCreateMenuOpen, setIsCreateMenuOpen] = useState(false);
  const history = useHistory();

  useEffect(() => {
    notificationsStore.getNotifications((notificationsLength) => {
      const isAfterLogin = window.localStorage.getItem('showNotifications') === '1';
      if (isAfterLogin && notificationsLength === 0) {
        setIsNotificationPanelOpen(false);
      }
      window.localStorage.removeItem('showNotifications');
    });
    return () => {
      // cleanup
    }
  }, [notificationsStore])

  useEffect(() => {
    if (!userStore.isDemoOrReadOnlyMode && window.localStorage.getItem('showNotifications') === '1') {
      setIsNotificationPanelOpen(true);
    }
    return () => {
      // cleanup
    }
  }, [userStore])

  useEffect(() => { // enforce desktop view in smaller devices(only after onboarding flow)
    if (
      uiStore.isMobileView &&
      uiStore.windowWidth < 785 &&
      uiStore.isMobileViewMessageSeen &&
      !userStore.data?.profile?.showTier4FirstTimeExperiencePopup &&
      !userStore.isDemoTier &&
      !userStore.showAfterPaymentMobileModal
    ) {
      uiStore.setIsPhoneDesktopView(true);
    }
  }, [uiStore, userStore])

  const onNotificationItemClick = () => {
    setIsNotificationPanelOpen(false);
  }

  const onCreateSyncClick = (syncMode) => {
    createItemStore.setInstitutionStep(syncMode);
    createItemStore.setShowModal(true);
    setIsCreateMenuOpen(false);
  }

  const onCreateManuallyClick = () => {
    createItemStore.setCategoryStep(true);
    createItemStore.setShowModal(true);
    setIsCreateMenuOpen(false);
  }

  const onVaultClick = () => {
    navigateToURLWithState(history, ROUTES.vault.url, { openUpload: true });
    setIsCreateMenuOpen(false);
  }

  const handleItemAdded = () => {
    createItemStore.setShowModal(false);
    userStore.updateData();
  }

  const handleFilterBoxOnClick = () => {
    filtersStore.setShowDrawer(true);
  }

  const handleCreateItemModalClose = (isXButton) => {
    createItemStore.setIsPlaidInProcess(false);
    createItemStore.setIsSaltedgeInProcess(false);
    createItemStore.setShowModal(false);
    if (isXButton && [ADD_ITEM_STEP.PLAID_ACCOUNTS, ADD_ITEM_STEP.SALTEDGE_ACCOUNTS, ADD_ITEM_STEP.AKOYA_ACCOUNTS].includes(createItemStore.step) && uiStore.currentRoute === ROUTES.accounts.url) {
      window.location.reload();
    }
  }

  return <Observer>{() => (
    <HeaderWrapper displayStyle={uiStore.headerStyle}>

      <SearchBox>
        <HeaderSearchBox />
      </SearchBox>

      {withFilters &&
        <FiltersButton onClick={handleFilterBoxOnClick} ref={filterButtonRef} style={{ mrginLeft: 0 }}>
          <LottieHoverIcon hoverParentRef={filterButtonRef} lottieFile={lottieFilterIcon} style={{ width: '24px', height: '24px' }} speed={2} />
          Filters
          {filtersStore.countActiveFilters > 0 && <ParamTitleSelectionCount style={{ marginLeft: '2px' }}>{filtersStore.countActiveFilters}</ParamTitleSelectionCount>}
        </FiltersButton>
      }


      <HeaderActions>
        <Dropdown
          overlay={CreateMenu({
            onSyncClick: onCreateSyncClick,
            onManuallyClick: onCreateManuallyClick,
            onVaultClick: onVaultClick,
            userStore: userStore,
            setMenuVisibility: setIsCreateMenuOpen
            // isIncognitoMode:uiStore.isIncognitoMode, 
            // onItemClick: onProfileActionClick, 
            // changeToIncognitoMode: ()=>{uiStore.setIsIncognitoMode(!uiStore.isIncognitoMode)}
          })}
          trigger={[
            // 'hover',
            'click']}
          placement="bottomRight"
          visible={isCreateMenuOpen}
          onVisibleChange={(visible) => { setIsCreateMenuOpen(visible) }}>
          <CreateButton createBlack={createBlack}><PlusIcon /> Add asset</CreateButton>
        </Dropdown>
        {/* {userStore.isFreeTier && <UpgradeButton onClick={()=>{billingStore.setShowPricingTableModal(true)}}><UpgradeCrownIcon />Upgrade</UpgradeButton>} */}
        <Dropdown overlay={UserNotificationsMenu({ onItemClick: onNotificationItemClick })} trigger={['click']} visible={isNotificationPanelOpen}
          onVisibleChange={(visible) => { setIsNotificationPanelOpen(visible) }} >

          <NotificationsButtonWrapper isOpenState={isNotificationPanelOpen} >
            {!notificationsStore.isFetchingNotifications && notificationsStore.displayedNotifications.length ?
              <NotificationsBellIconBadge isOpenState={isNotificationPanelOpen} /> : null}
            <NotificationsBellIcon />
          </NotificationsButtonWrapper>
        </Dropdown>
      </HeaderActions>


      {createItemStore.showModal && <NewCreateItemModal onAddItem={() => { handleItemAdded() }} onClose={handleCreateItemModalClose} />}


      {createItemStore.isShowAddManualItemLimitModal && <LimitationModal modalType="addItems"
        paramsForText={[userStore.userLimitations.manualActiveItems.manualItems]}
        onUpgrade={() => { billingStore.setShowPricingTableModal(true) }}
        onClose={() => createItemStore.setShowAddManualItemLimitModal(false)} />}

      {createItemStore.isShowAddSyncLimitModal && <LimitationModal modalType="instSync"
        paramsForText={[userStore.userLimitations.financialInstitutionSync.syncedInstitutions]}
        onUpgrade={() => { billingStore.setShowPricingTableModal(true) }}
        onClose={() => createItemStore.setShowAddSyncLimitModal(false)} />}

      {createItemStore.isShowAddVipSyncLimitModal && <LimitationModal modalType="vipSync"
        paramsForText={[userStore.userLimitations.financialInstitutionSync.syncedInstitutions]}
        onUpgrade={() => { billingStore.setShowPricingTableModal(true) }}
        onClose={() => createItemStore.setShowAddVipSyncLimitModal(false)} />}

    </HeaderWrapper>
  )}</Observer>
}

export function CreateMenu({
  isMobileMenu,
  onClose,
  fullWidth,
  setMenuVisibility,
  onSyncClick,
  userStore,
  onVaultClick,
  onManuallyClick
}) {
  const handlers = useSwipeable(isMobileMenu ? {
    onSwipedDown: (eventData) => {
      onClose?.()
    }
  } : {});

  return (
    <MenuWrapper width={fullWidth ? '100%' : '350px'} {...handlers}>
      <MenuSectionHeader>Automations</MenuSectionHeader>
      <ActionLocked padding={'0 16px'} action={'createItemInvestor'} blockCb={() => { setMenuVisibility(false) }}>
        <MenuItemWrapper onClick={() => { onSyncClick('investor') }}>
          <CreateMenuItemWrapper>
            <CreateMenuItemIcon>
              <CreateMenuInvsIcon />
            </CreateMenuItemIcon>
            <CreateMenuItemTextContent>
              <CreateMenuItemTitle>Sync an investor portal</CreateMenuItemTitle>
              <CreateMenuItemSubTitle>Search for any operator / sponsor / private fund account.</CreateMenuItemSubTitle>
            </CreateMenuItemTextContent>
          </CreateMenuItemWrapper>
          {userStore?.isActionBlockedByRole('createItemInvestor') && <ActionLockedIconWithTooltip placement={'left'} iconColor={'#9097A3'} isRoleBlocked={true} />}
        </MenuItemWrapper>
      </ActionLocked>

      <ActionLocked padding={'0 16px'} action={'createItemBank'} blockCb={() => { setMenuVisibility(false) }}>
        <MenuItemWrapper id='add-item-modal-sync-bank' onClick={() => { onSyncClick('bank') }}>
          <CreateMenuItemWrapper>
            <CreateMenuItemIcon>
              <SyncBankSvg />
            </CreateMenuItemIcon>
            <CreateMenuItemTextContent>
              <CreateMenuItemTitle>Sync bank & brokerage accounts</CreateMenuItemTitle>
              <CreateMenuItemSubTitle>Securely sync a bank / brokerage / long term savings account.</CreateMenuItemSubTitle>
            </CreateMenuItemTextContent>
          </CreateMenuItemWrapper>
          {userStore?.isActionBlockedByRole('createItemBank') && <ActionLockedIconWithTooltip placement={'left'} iconColor={'#9097A3'} isRoleBlocked={true} />}
        </MenuItemWrapper>
      </ActionLocked>

      <ActionLocked padding={'0 16px'} action={'createItemByAI'} blockCb={() => { setMenuVisibility(false) }}>
        <MenuItemWrapper onClick={onVaultClick}>
          <CreateMenuItemWrapper>
            <CreateMenuItemIcon>
              <CreateMenuMagicBoxIcon />
            </CreateMenuItemIcon>
            <CreateMenuItemTextContent>
              <AssistanceHeroLogoWrapper style={{ border: 'none' }}>
                <VyzerAIAssistanceIcon />
                <AssistanceHeroLogoText>{'AI-BETA'}</AssistanceHeroLogoText>
              </AssistanceHeroLogoWrapper>
              <CreateMenuItemTitle>Create from files</CreateMenuItemTitle>
              <CreateMenuItemSubTitle>Convert any financial document to assets.</CreateMenuItemSubTitle>
            </CreateMenuItemTextContent>
          </CreateMenuItemWrapper>
          {userStore?.isActionBlockedByRole('createItemByAI') && <ActionLockedIconWithTooltip placement={'left'} iconColor={'#9097A3'} isRoleBlocked={true} />}
        </MenuItemWrapper>
      </ActionLocked>

      <div style={{ width: '100%', height: '1px', backgroundColor: '#DDE3EB', }}></div>
      <MenuSectionHeader>Manual process</MenuSectionHeader>
      <ActionLocked padding={'0 16px'} action={'createItemManually'} blockCb={() => { setMenuVisibility(false) }}>
        <MenuItemWrapper onClick={onManuallyClick} style={{ justifyContent: 'flex-start' }}>
          <CreateMenuItemWrapper>
            <CreateMenuItemIcon>
              <ManualItemSvg />
            </CreateMenuItemIcon>
            <CreateMenuItemTextContent>
              <CreateMenuItemTitle>Add manually</CreateMenuItemTitle>
              <CreateMenuItemSubTitle>Add any type of asset or liability</CreateMenuItemSubTitle>
            </CreateMenuItemTextContent>
          </CreateMenuItemWrapper>
          {userStore?.isActionBlockedByRole('createItemManually') && <ActionLockedIconWithTooltip placement={'left'} marginLeft={'auto'} iconColor={'#9097A3'} isRoleBlocked={true} />}
        </MenuItemWrapper>
      </ActionLocked>
    </MenuWrapper>
  )
}

function UserNotificationsMenu(props) {
  return <NotificationsMenuWrapper><Notifications onItemClick={props.onItemClick} /></NotificationsMenuWrapper>
}

const SyncBankSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
      <line x1="18.5" y1="23" x2="18.5" y2="34" stroke="#585D66" />
      <line x1="15.5" y1="28" x2="15.5" y2="35" stroke="#585D66" />
      <line x1="21.5" y1="29" x2="21.5" y2="40" stroke="#585D66" />
      <line x1="24.5" y1="36" x2="24.5" y2="41" stroke="#585D66" />
      <line x1="27.5" y1="35" x2="27.5" y2="40" stroke="#585D66" />
      <line x1="30.5" y1="35" x2="30.5" y2="46" stroke="#585D66" />
      <line x1="33.5" y1="30" x2="33.5" y2="41" stroke="#585D66" />
      <line x1="36.5" y1="28" x2="36.5" y2="35" stroke="#585D66" />
      <line x1="39.5" y1="22" x2="39.5" y2="33" stroke="#585D66" />
      <line x1="42.5" y1="22" x2="42.5" y2="28" stroke="#585D66" />
      <line x1="45.5" y1="25" x2="45.5" y2="31" stroke="#585D66" />
      <line x1="48.5" y1="21" x2="48.5" y2="32" stroke="#585D66" />
    </svg>
  )
}

const ManualItemSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
      <path d="M42 18H47L47 37.5" stroke="#585D66" />
      <path d="M35.6 49L18 49L18 16L42 16L42 35" stroke="#585D66" />
      <path d="M42.4496 35L42.5975 35.5236C42.9488 36.7679 44.3707 37.3569 45.499 36.7254L45.9737 36.4597L47.7713 38.2573L47.5056 38.7321C46.8742 39.8604 47.4632 41.2823 48.7075 41.6336L49.2311 41.7814V44.3236L48.7075 44.4715C47.4632 44.8228 46.8742 46.2447 47.5056 47.373L47.7713 47.8478L45.9737 49.6454L45.5403 49.4028C44.3991 48.7641 42.962 49.3745 42.6293 50.6392L42.4496 51.3223L39.9074 51.1051L39.7596 50.5815C39.4083 49.3372 37.9864 48.7482 36.8581 49.3796L36.3833 49.6454L34.5857 47.8477L34.8514 47.373C35.4828 46.2447 34.8939 44.8228 33.6496 44.4715L33.126 44.3236L33.126 41.7814L33.6496 41.6336C34.8939 41.2823 35.4829 39.8604 34.8514 38.7321L34.5857 38.2573L36.3833 36.4597L36.8581 36.7254C37.9864 37.3569 39.4083 36.7679 39.7596 35.5236L39.9074 35H42.4496Z" stroke="#585D66" strokeLinejoin="round" />
      <circle cx="41.1786" cy="43.1604" r="2.96591" stroke="#585D66" />
      <line x1="22" y1="26.5" x2="29" y2="26.5" stroke="#585D66" />
      <line x1="22" y1="22.5" x2="29" y2="22.5" stroke="#585D66" />
    </svg>
  )
}